// Contracts
const DIAMOND_PACK_CONTRACT = 'diamond-pack';
const DIAMOND_PACK_INCREMENT = 100;
const PREMIUM_PACK_CONTRACT = 'premium-pack';
const PREMIUM_PACK_INCREMENT = 30;

// Payment methods
const FIXED_PAYMENT_METHOD_MAX = 6000;
const FIXED_PAYMENT_METHOD_MULTIPLE = 30;
const FIXED_PAYMENT_METHOD_VALUE = 'installment';

const VARIABLE_PAYMENT_METHOD_MIN = 10;
const VARIABLE_PAYMENT_METHOD_MAX = 90;
const VARIABLE_PAYMENT_METHOD_INCREMENT = 5;
const VARIABLE_PAYMENT_METHOD_VALUE = 'percentage';

const SINGLE_PAYMENT_METHOD_VALUE = 'full';

const PaymentMethodHelper = {
    FIXED_PAYMENT_METHOD_VALUE,

    VARIABLE_PAYMENT_METHOD_VALUE,

    SINGLE_PAYMENT_METHOD_VALUE,

    // Generates sequence incremented by contract name type
    generateSequence(min, max, increment) {
        let numbers = [];
        let number = min;

        numbers.push(number);

        for (let i = 0; number < max; i++) {
            number += increment;
            numbers.push(number);
        }

        return numbers;
    },

    generateSequenceFixed(min, max) {
        let numbers = [];
        let number = min;

        numbers.push(number);

        for (let i = 0; number < max; i++) {
            number = number + FIXED_PAYMENT_METHOD_MULTIPLE;
            numbers.push(number);
        }

        return numbers;
    },

    getFeeAmountIncrease(contractName) {
        return [DIAMOND_PACK_CONTRACT, PREMIUM_PACK_CONTRACT].includes(contractName)
            ? DIAMOND_PACK_INCREMENT
            : PREMIUM_PACK_INCREMENT;
    },

    getFixedPaymentMethodOptions(creditLimit, contractName = DIAMOND_PACK_CONTRACT) {
        creditLimit = creditLimit ? creditLimit : FIXED_PAYMENT_METHOD_MAX;
        const min = Math.ceil((0.1 * creditLimit) / FIXED_PAYMENT_METHOD_MULTIPLE) * FIXED_PAYMENT_METHOD_MULTIPLE;
        const max = Math.floor(creditLimit / FIXED_PAYMENT_METHOD_MULTIPLE) * FIXED_PAYMENT_METHOD_MULTIPLE;
        const increment = PaymentMethodHelper.getFeeAmountIncrease(contractName);
        const sequence = PaymentMethodHelper.generateSequenceFixed(min, max);

        return {
            min,
            max,
            increment,
            list: sequence.map(item => ({
                value: item,
                label: String(item).concat('€'),
            })),
        };
    },

    getVariablePaymentMethodOptions() {
        const sequence = PaymentMethodHelper.generateSequence(
            VARIABLE_PAYMENT_METHOD_MIN,
            VARIABLE_PAYMENT_METHOD_MAX,
            VARIABLE_PAYMENT_METHOD_INCREMENT
        );

        return sequence.map(item => ({
            value: item,
            label: String(item).concat('%'),
        }));
    },
};

module.exports = PaymentMethodHelper;
